import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  Col, Row, Label, FormText,
} from 'reactstrap';
import PriceRow from './PriceRow';
import { splitByThousands } from '../../helpers/helper';
import { Prices } from '../../helpers/propTypes';

class View extends PureComponent {
  render() {
    const {
      initialPrices, isFree, freeMessage, newPrices, title, notice,
    } = this.props;
    const initialDetails = initialPrices.details;
    const newPriceDetails = !$.isEmptyObject(newPrices) ? newPrices.details : initialDetails;
    const priceNames = {
      basePrice: '基本料金',
      rentalPrices: 'レンタル代',
      pcRentalFee: 'PCレンタル代',
      travelCost: '宿泊費',
    };

    const discountNames = {
      couponDiscount: 'クーポン割引',
      paymentDiscount: '支払方法割引',
      preentryDiscount: 'プレエントリー割引',
    };

    return (
      <>
        <Label className="font-weight-bold">{title}</Label>
        <div className="price">
          {!isFree ? (
            <>
              <Row>
                <Col sm={5} xs={3}>内訳</Col>
                <Col sm={7} xs={9}>
                  <>
                    {Object.keys(priceNames).map((key) => {
                      if (key === 'rentalPrices') {
                        if (newPriceDetails.rentalPrices.rentals.length !== initialDetails.rentalPrices.rentals.length
                            || newPriceDetails.rentalPrices.rentals.some((val, index) => val.price !== initialDetails.rentalPrices.rentals[index].price)) {
                          return (
                            <React.Fragment key="rentalPrices">
                              {initialDetails.rentalPrices.rentals.length > 0 && initialDetails.rentalPrices.rentals.map((rental) => (
                                <PriceRow key={rental.id} price={rental.price} name={`${rental.name}${priceNames.rentalPrices}`} strike />
                              ))}
                              {newPriceDetails.rentalPrices.rentals.length > 0 && newPriceDetails.rentalPrices.rentals.map((rental) => (
                                <PriceRow key={rental.id} price={rental.price} name={`${rental.name}${priceNames.rentalPrices}`} red />
                              ))}
                              {initialDetails.rentalPrices.rentals.length > 0 && newPriceDetails.rentalPrices.rentals === 0 && (
                                <PriceRow price={0} name="レンタル無し" red noTitle />
                              )}
                            </React.Fragment>
                          );
                        }
                        return (
                          initialDetails[key].rentals.length > 0 && initialDetails[key].rentals.map((rental) => (
                            <PriceRow key={rental.id} price={rental.price} name={`${rental.name}${priceNames[key]}`} />
                          ))
                        );
                      }
                      return (
                        <React.Fragment key={key}>
                          <PriceRow price={initialDetails[key]} name={priceNames[key]} strike={initialDetails[key] !== newPriceDetails[key]} />
                          {initialDetails[key] !== newPriceDetails[key] && <PriceRow key={`new${key}`} price={newPriceDetails[key]} name={priceNames[key]} red noTitle />}
                        </React.Fragment>
                      );
                    })}
                    { Object.keys(discountNames).map((key) => (
                      <PriceRow key={key} price={newPriceDetails[key]} name={discountNames[key]} />
                    ))}
                    {Array.isArray(newPriceDetails.earlyDiscounts) && newPriceDetails.earlyDiscounts.length > 0
                      ? newPriceDetails.earlyDiscounts.map((d, i) => (
                        <PriceRow key={`earlyDiscount-${i}`} price={d.amount} name={d.name} />
                      ))
                      : <PriceRow key="earlyDiscount" price={newPriceDetails.earlyDiscount} name="自動割引" />}
                  </>
                </Col>
              </Row>
              <hr />
            </>
          ) : null}
          {!isFree && (
          <p className="pre-tax text-right">
            税別
            {splitByThousands(!$.isEmptyObject(newPrices) ? newPrices.priceBeforeTax : initialPrices.priceBeforeTax)}
            円
          </p>
          )}
          {!$.isEmptyObject(newPrices) && initialPrices.price !== newPrices.price ? (
            <>
              <Row className="mt-4">
                <Col sm={5} xs={3} className="total">合計金額</Col>
                <Col>変更前</Col>
                <Col className="text-right">
                  税込
                  <strike>
                    <span style={{ fontSize: '20px' }}>
                      {splitByThousands(initialPrices.price)}
                    </span>
                    円
                  </strike>
                </Col>
              </Row>
              <Row>
                <Col sm={5} xs={3} />
                <Col className="total">変更後</Col>
                <Col className="total-price text-right">
                  税込
                  <span>
                    {splitByThousands(newPrices.price)}
                  </span>
                  円
                </Col>
              </Row>
              <hr />
              <Row className="mt-3">
                <Col sm={5} xs={3} />
                <Col className="total red"><span>差額</span></Col>
                <Col className="total-price text-right">
                  税込
                  <span>
                    {splitByThousands(newPrices.price - initialPrices.price)}
                  </span>
                  円
                </Col>
              </Row>
            </>
          ) : (
            <Row>
              <Col sm={5} xs={3} className="total">合計金額</Col>
              <Col className="total-price text-right">
                税込
                <span>
                  {(() => {
                    if (isFree) return 0;
                    return splitByThousands(initialPrices.price);
                  })()}
                </span>
                円
              </Col>
            </Row>
          )}
          { isFree && (<FormText color="danger" style={{ fontSize: '14px' }}>{freeMessage}</FormText>)}
          { notice && (<FormText color="danger" style={{ fontSize: '14px' }}>{notice}</FormText>)}
        </div>
      </>
    );
  }
}

View.defaultProps = {
  newPrices: null,
  title: 'お支払い金額',
  notice: null,
};

View.propTypes = {
  initialPrices: Prices.isRequired,
  newPrices: Prices,
  isFree: PropTypes.bool.isRequired,
  freeMessage: PropTypes.string.isRequired,
  title: PropTypes.string,
  notice: PropTypes.string,
};

export default View;
